import { msalInstance } from '@/utils/auth';

async function acquireToken(account: any, scopes: string[]) {
  try {
    const silent = await msalInstance.acquireTokenSilent({ account, scopes });
    return silent.accessToken;
  } catch (silentError) {
    console.warn('Silent token failed:', silentError);

    try {
      const popup = await msalInstance.acquireTokenPopup({ account, scopes });
      return popup.accessToken;
    } catch (popupError) {
      console.error('Popup token failed:', popupError);
      msalInstance.logoutRedirect();
      return null;
    }
  }
}

export function prepareHeadersWithScopes(scopes: string[]) {
  return async (headers: Headers) => {
    const account = msalInstance.getAllAccounts()?.[0];
    if (!account) return headers;

    const token = await acquireToken(account, scopes);
    if (token) headers.set('Authorization', `Bearer ${token}`);

    return headers;
  };
}

export const prepareHeadersWithAuthorization = prepareHeadersWithScopes([
  `${import.meta.env.VITE_MSAL_CLIENT_ID}/.default`,
]);

export const prepareHeadersWithAuthorizationPhoto = prepareHeadersWithScopes([
  'User.Read',
]);
